// extracted by mini-css-extract-plugin
export default {"decWrapper":"description_decWrapper__FQ0Cm","header":"description_header__hzkCs","textWrapper":"description_textWrapper__BwnOI","contractClass":"description_contractClass__XchoW"};